import { createApp } from 'vue';
import FlyoverShare from './FlyoverShare.vue';
import { i18n } from '../../i18n';

// Mount only on pages that include the mount point (recording and hike pages, the hikes list).
const targetElement = document.querySelector('#flyover_share');
if (targetElement) {
  const app = createApp(FlyoverShare);
  app.use(i18n);
  const vm = app.mount(targetElement) as unknown as { showFlyover: (cfg: unknown) => void };
  // Global entry point the recording and hike share options open the wizard through.
  (window as unknown as { showFlyoverShare?: (cfg: unknown) => void }).showFlyoverShare = (cfg) =>
    vm.showFlyover(cfg);
}
